// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"39":"5aef1492","45":"23c9cb41"}[chunkId] + ".chunk.css";
};